import { render, staticRenderFns } from "./ListPagerComponent.vue?vue&type=template&id=4358d3ca&scoped=true"
import script from "./ListPagerComponent.vue?vue&type=script&lang=js"
export * from "./ListPagerComponent.vue?vue&type=script&lang=js"
import style0 from "./ListPagerComponent.vue?vue&type=style&index=0&id=4358d3ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4358d3ca",
  null
  
)

export default component.exports